import { render, staticRenderFns } from "./LanguageListWidget.vue?vue&type=template&id=3f875902&"
import script from "./LanguageListWidget.vue?vue&type=script&lang=js&"
export * from "./LanguageListWidget.vue?vue&type=script&lang=js&"
import style0 from "./LanguageListWidget.vue?vue&type=style&index=0&id=3f875902&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports